import { Box } from '@mui/material'
import React, { useContext } from 'react'
import { ToolContext } from '../../../core/context/ToolContext'
import Account from './Modal/Account'
import { Cafgu } from '../home/Modal/Cafgu'
import AddTour from '../personalization/AddTour'

const UbrAccount = () => {
    const {career_state } = useContext(ToolContext)
    const {welcome, cafguModal, pznlTour, addTour} = career_state
    // const {__Session} = tool_state
 
    return (
        <Box>
            {/* <Home /> */}
            <Account welcome={welcome} cafguModal={cafguModal}/>
            <Cafgu cafguModal={cafguModal} pznlTour={pznlTour} addTour={addTour}/>
            {/* <znlTour pznlTour={pznlTour} /> */}
            <AddTour addTour={addTour}/>
            
        </Box>
    )
}

export default UbrAccount
